import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

var _templateObject;

var _excluded = ["children"],
    _excluded2 = ["children"],
    _excluded3 = ["children"],
    _excluded4 = ["children"],
    _excluded5 = ["children", "hideStoreName"];
import React, { useMemo, useEffect } from 'react';
import { useQuery, gql } from '@apollo/client';
export { default as HeadProvider } from './headProvider';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { useUserContext } from '@magento/peregrine/lib/context/user';
Helmet.defaultProps.defer = false;
export var Link = function Link(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, _excluded);

  return React.createElement(Helmet, null, React.createElement("link", tagProps, children));
};
export var Meta = function Meta(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, _excluded2);

  return React.createElement(Helmet, null, React.createElement("meta", tagProps, children));
};
export var Style = function Style(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, _excluded3);

  return React.createElement(Helmet, null, React.createElement("style", tagProps, children));
};
export var Title = function Title(props) {
  var children = props.children,
      tagProps = _objectWithoutProperties(props, _excluded4);

  return React.createElement(Helmet, null, React.createElement("title", tagProps, children));
};
var STORE_NAME_QUERY = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    query getStoreName {\n        # eslint-disable-next-line @graphql-eslint/require-id-when-available\n        storeConfig {\n            store_code\n            store_name\n        }\n    }\n"])));
var lastTrackedPath = null;
export var StoreTitle = function StoreTitle(props) {
  var children = props.children,
      _props$hideStoreName = props.hideStoreName,
      hideStoreName = _props$hideStoreName === void 0 ? false : _props$hideStoreName,
      tagProps = _objectWithoutProperties(props, _excluded5);

  var _useLocation = useLocation(),
      pathname = _useLocation.pathname;

  var _useQuery = useQuery(STORE_NAME_QUERY),
      storeNameData = _useQuery.data;

  var _useUserContext = useUserContext(),
      _useUserContext2 = _slicedToArray(_useUserContext, 1),
      currentUser = _useUserContext2[0].currentUser;

  var storeName = useMemo(function () {
    return storeNameData ? storeNameData.storeConfig.store_name : STORE_NAME;
  }, [storeNameData]);
  var titleText;

  if (children) {
    if (hideStoreName) {
      titleText = children;
    } else {
      titleText = "".concat(children, " - ").concat(storeName);
    }
  } else {
    titleText = storeName;
  }

  useEffect(function () {
    if (titleText && titleText !== 'Hubbardton Forge') {
      var _hsq = window._hsq = window._hsq || [];

      _hsq.push(['setPath', pathname]);

      _hsq.push(['trackPageView']);

      _hsq.push(['identify', {
        email: (currentUser === null || currentUser === void 0 ? void 0 : currentUser.email) || ''
      }]);
    }
  }, [titleText, pathname, currentUser === null || currentUser === void 0 ? void 0 : currentUser.email]); // GTM turns this into the GA4 page_view (one per route, once the page title is known).

  useEffect(function () {
    if (children && pathname !== lastTrackedPath) {
      lastTrackedPath = pathname;
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'virtual_page_view',
        page_title: titleText,
        page_path: pathname,
        page_location: window.location.href
      });
    }
  }, [children, pathname, titleText]);
  return React.createElement(Helmet, null, React.createElement("title", tagProps, titleText));
};